<app-splash-screen (animationCompleted)="onSplashAnimationCompleted()"></app-splash-screen>

<div class="app-content" [style.visibility]="appContentVisible ? 'visible' : 'hidden'">
  <app-header></app-header>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>